import React, { useContext, useEffect, useState } from "react";
import Button from "../../../Button";
import Radio from "../../../CommonComponents/Radio";
import AlertContext from "../../../../context/AlertContext";
import { nanoid } from "nanoid";
import InputField from "../../../CommonComponents/InputField";
import RichTextEditor from "../../../CommonComponents/RichTextEditor";
import TopicComplexity from "../TopicComplexity";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import { useNavigate, useParams } from "react-router-dom";
import constants, { RESULT_STATUS } from "../../../../constants";
import ReusableBreadcrumbs from "../../../CommonComponents/ReusableBreadCrumbs";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import { getDataFromStorage } from "../../../../util";
import Textarea from "../../../CommonComponents/Textarea";
import Toast from "../../../CommonComponents/Toast";
import Loading from "../../../Notification-Loading/Loading/Loading";

const validator = {
  name: (value) => (!value || value.trim() === "" ? "Name is required" : null),
  saqlaqAnswer: (value, validation) => {
    const strValue = String(value ?? "");
    if (!strValue.trim()) {
      return "Answer is required";
    }
    if (validation == 1 && !/^\d*$/.test(value)) {
      return "Alpha numeric is not allowed";
    }
    return null;
  },

  datatype: (value) => (!value ? "Validation rule is required" : null),
  topicData: (value) => {
    if (!value || value.length === 0) {
      return "At least one topic and complexity must be selected";
    } else {
      for (let i = 0; i < value.length; i++) {
        if (!value[i].topicId || !value[i].complexityId) {
          return "Both topic and complexity are required for each entry";
        }
      }
    }
    return null;
  },
};

const CodingSnippetEntry = (Props) => {
  const Alert = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const navigate = useNavigate();
  const { type, questionid } = useParams();

    const [dataIsLoading, setDataIsLoading] = useState(false);
  

  const [questionDetail, setQuestionDetail] = useState({
    name: "",
    description: "",
    saqlaqAnswer: "",
    topicData: [],
    datatype: 1,
  });
  const [errors, setErrors] = useState({});
  const [topics, setTopics] = useState([]);
  const [complexity, setComplexity] = useState([]);
  const [topicData, setTopicData] = useState([]);
  const [toastType, setToastType] = useState("warning");
  const [openToast, setOpenToast] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  let option = [
    {
      value: 1,
      label: "Numeric",
    },
    {
      value: 2,
      label: "Alpha Numeric",
    },
  ];

  const buildTopicComplexity = (topicDataStr, topics, complexity) => {
    if (!topicDataStr) return [];

    let parsed = [];
    try {
      parsed = JSON.parse(topicDataStr);
    } catch (e) {
      console.error("Invalid topicData JSON", e);
      return [];
    }
    return parsed
      .map(({ topicid, complexityid }) => {
        const topic = topics.find((t) => t.value === topicid);
        const comp = complexity.find((c) => c.value === complexityid);
        if (!topic || !comp) return null;

        return {
          id: nanoid(),
          topicId: topicid,
          topicName: topic.label,
          complexityId: complexityid,
          complexityName: comp.label,
        };
      })
      .filter(Boolean);
  };

  useEffect(() => {
    const fetchTopicsComplexity = async () => {
      try {
        const [topics, complexity] = await Promise.all([
          axios.get("node/admin/topic/get/0"),
          axios.get("node/admin/complexity/get"),
        ]);
        let editTopics = []
        if(topics.data.resultCode === RESULT_STATUS.SUCCESS){
          editTopics = topics.data.data?.map((topic) => ({
            value: topic.id,
            label: topic.name,
          }));
          setTopics(
            topics.data.data?.map((topic) => ({
              value: topic.id,
              label: topic.name,
            })),
          );
        }
        let editComplexity = complexity.data?.map((comp) => ({
          value: comp.id,
          label: comp.name,
        }));
        setComplexity(
          complexity.data?.map((comp) => ({
            value: comp.id,
            label: comp.name,
          })),
        );
        return { editTopics, editComplexity };
      } catch (error) {
        console.error("Error fetching topics and complexity:", error);
      }
    };

    const getQuestionDetails = async () => {
      try {
        setDataIsLoading(true);
        if (getDataFromStorage("role") === constants.Roles.tutor)
          Alert.setPreview(true);
        // Determine the endpoint based on the `id` value

        const endpoint = `node/admin/content/${questionid}`;

        console.log("endPoint:", endpoint);

        const response = await axios.get(
          endpoint,
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );

        let json = response.data;
        let newData;

        newData = json.data;

        newData.qnId = questionid;
        newData.published = 0;

        console.log("newData:", newData);

        const { editTopics, editComplexity } = await fetchTopicsComplexity();
        const normalizeAnswers = (answers = []) =>
          answers.map((ans) => ans.answerText);

        //topicCompexity
        setQuestionDetail((prev) => {
          const updatedAnswers = normalizeAnswers(newData.answers ?? []);
          const baseTopicComplexity = buildTopicComplexity(
            newData.topicData,
            editTopics,
            editComplexity,
          );
          let finalTopicComplexity = baseTopicComplexity;
          setTopicData(finalTopicComplexity);
          return {
            ...prev,
            name: newData?.name,
            questionType: newData.type === constants.libTypeIds.LAQ,
            description: newData?.description,
            saqlaqAnswer: updatedAnswers,
            topicComplexity: finalTopicComplexity,
            datatype: newData?.datatype,
          };
        });
      } catch (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
        // setQueLoading(true);
      } finally {
        setDataIsLoading(false);
      }
    };

    questionid && getQuestionDetails();
  }, [questionid]);

  useEffect(() => {
    const fetchTopicsComplexity = async () => {
      try {
        const [topics, complexity] = await Promise.all([
          axios.get("node/admin/topic/get/0"),
          axios.get("node/admin/complexity/get"),
        ]);
        // console.log(topics, complexity);
        if(topics.data.resultCode === RESULT_STATUS.SUCCESS)       
          setTopics(
            topics.data?.data?.map((topic) => ({ value: topic.id, label: topic.name })),
          );
        setComplexity(
          complexity.data?.map((comp) => ({
            value: comp.id,
            label: comp.name,
          })),
        );
      } catch (error) {
        console.error("Error fetching topics and complexity:", error);
      }
    };
    !questionid && fetchTopicsComplexity();
  }, [axios]);

  const onSave = async (edit, id) => {
    //validate all fields
    console.log("edit:", edit);
    const formData = new FormData();

    const nameError = validator.name(questionDetail.name);
    const answersError = validator.saqlaqAnswer(
      questionDetail.saqlaqAnswer,
      questionDetail.datatype,
    );
    const topicComplexityError = validator.topicData(topicData);
    const validationError = validator.datatype(questionDetail?.datatype);

    const allErrors = {
      name: nameError,
      saqlaqAnswer: answersError,
      topicComplexity: topicComplexityError,
      datatype: validationError,
    };
    setErrors(allErrors);

    const hasErrors = Object.values(allErrors).some((error) => error !== null);
    if (!hasErrors) {
      //submit the form
      console.log("Form is valid. Submitting...", questionDetail);
      // console.log("topicAnDComplexity:", topicData);
      const updatedQuestionDetail = {
        ...questionDetail,
        saqlaqAnswer: [questionDetail.saqlaqAnswer],
      };

      setQuestionDetail(updatedQuestionDetail);
      let qdata = {
        ...updatedQuestionDetail,
        topicData: topicData,
        secData: topicData.map((tc) => ({
          complexityId: tc.complexityId,
        })),
        complexity: topicData.map((tc) => ({
          complexityId: tc.complexityId,
        })),
      };

      if (id) {
        qdata.id = id;
      }

      qdata = JSON.stringify({
        qdata,
      });
      const libtypename = "Coding Snippet";
      formData.append("qdata", qdata);
      formData.append("libtypeid", 12);
      formData.append("libtypename", libtypename);
      // console.log("formData:", formData);

      try {
        setDataIsLoading(true)
        const response = await axios({
          method: "post",
          url: `node/admin/library/${edit ? "update" : "add"}`,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response,", response);
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            msg: `${response.data.message}`,
            title: "Success !",
          });
          // Alert.handleNavigateToLpAfterAddTest(newDetails);
          navigate("/library/12/questionlist");
        }
        if (
          response.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR
        ) {
          throw new Error(response.data.msg);
        }
      } catch (error) {
        Alert.setShowNotify({
          show: true,
          msg: `${`Something went wrong while ${edit ? "updating" : "adding"} Coding Snippet Question`}`,
          title: "Error !",
        });
      }
      finally{
        setDataIsLoading(false);
      }
    } else {
      console.log("Form has errors. Fix them before submitting.", allErrors);
      setOpenToast(true);
      setErrMsg("Please fill the highlighted fields.");
    }
  };

  const onChangeQuestionDetail = (field, value) => {
    // console.log(field, value);
    let error;
    if (field === "saqlaqAnswer") {
      error = validator[field]
        ? validator[field](value, questionDetail?.datatype)
        : null;
    } else {
      error = validator[field] ? validator[field](value) : null;
    }
    setQuestionDetail((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));
  };
  const onAddTopicComp = (topicId, complexityId) => {
    const topic = topics.find((t) => t.value === topicId);
    const complexityLevel = complexity.find((c) => c.value === complexityId);

    if (!topic || !complexityLevel) return;
    const newTopicComplexity = {
      id: nanoid(),
      topicId: topic.value,
      topicName: topic.label,
      complexityId: complexityLevel.value,
      complexityName: complexityLevel.label,
    };

    setTopicData((prev) => {
      const isAlreadyAdded = prev.some(
        (tc) =>
          tc.topicId === topic.value &&
          tc.complexityId === complexityLevel.value,
      );

      if (isAlreadyAdded) {
        // console.log("Topic and complexity already added");
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: `Topic "${topic?.label}" already added!`,
        });
        return prev;
      }

      return [...prev, newTopicComplexity];
    });

    setQuestionDetail((prev) => {
      const prevList = prev.topicComplexity ?? [];

      const isAlreadyAdded = prevList.some(
        (tc) =>
          tc.topicId === topic.value &&
          tc.complexityId === complexityLevel.value,
      );

      if (isAlreadyAdded) {
        return prev;
      }

      return {
        ...prev,
        topicData: [...prevList, newTopicComplexity],
      };
    });

    setErrors((prev) => ({
      ...prev,
      topicComplexity: null,
    }));
  };
  const onRemoveTopicComp = (id) => {
    // console.log("Remove topic complexity", id);
    setTopicData((prev) => prev.filter((tc) => tc.id !== id));
  };

  const breadcrumbItems = [
    { label: "Library" },
    {
      label: `Coding Snippet`,
      href: `/library/${type}/questionlist`,
    },
    { label: `${questionid ? "Edit" : "Add"} Question` },
  ];

  console.log("errors;", errors);
  console.log("questionDetails:", questionDetail);

  return (
    <div className="coding-snippet-question-entry-main-container">
      {dataIsLoading && <Loading />}

      <ReusableBreadcrumbs items={breadcrumbItems} />
      <Toast
        open={openToast}
        onClose={() => setOpenToast(false)}
        message={errMsg}
        type={toastType}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        // slots={{ transition: Slide }}
      />
      <section className="coding-snippet-question-entry-header-container">
        <div>{questionid ? "Update " : "Add "}Question</div>
        <Button
          size="sm"
          hierarchy={{
            type: "primary",
            buttonText: questionid ? "Update" : "Save",
          }}
          onClick={() => (questionid ? onSave("edit", questionid) : onSave())}
          disable={dataIsLoading}
        />
      </section>
      <section className="coding-snippet-question-entry-content-container">
        <div className="coding-snippet-question-entry-content-section-1">
          <InputField
            label="Main Question"
            name="name"
            placeholder="Enter the heading here"
            value={questionDetail.name}
            onChange={(event) =>
              onChangeQuestionDetail("name", event.target.value)
            }
            hintText={errors.name}
            destructive={!!errors.name}
          />
        </div>
        <div className="coding-snippet-question-entry-content-section-2">
          <RichTextEditor
            title="Description"
            name="description"
            value={questionDetail.description}
            onChange={(event) => onChangeQuestionDetail("description", event)}
          />
        </div>
        <div className="coding-snippet-question-entry-content-section-4">
          <TopicComplexity
            onAddTopicComp={onAddTopicComp}
            topicOptions={topics}
            complexityOptions={complexity}
            topicComplexity={topicData}
            onRemoveTopicComp={onRemoveTopicComp}
            errors={errors}
          />
        </div>
        <div className="coding-snippet-question-entry-content-validation-rule">
          <p>Validation Rule:</p>
          <div style={{ display: "flex", gap: "16px" }}>
            <Radio
              text="Numeric"
              size="sm"
              checked={questionDetail.datatype === 1}
              onChange={(checked) => onChangeQuestionDetail("datatype", 1)}
            />
            <Radio
              text="Alpha Numeric"
              size="sm"
              checked={questionDetail.datatype === 2}
              onChange={(checked) => onChangeQuestionDetail("datatype", 2)}
            />
          </div>
          <p className="error-validation-rule">{errors?.datatype}</p>
        </div>
        <div className="coding-snippet-question-entry-content-section-3">
          <Textarea
            label={"Answer"}
            name="saqlaqAnswer"
            placeholder={"Enter the answer"}
            value={questionDetail.saqlaqAnswer}
            onChange={(event) =>
              onChangeQuestionDetail("saqlaqAnswer", event.target.value)
            }
          />
          {errors.saqlaqAnswer && (
            <p className="coding-snippet-question-entry-content-section-3-error-text">
              {errors.saqlaqAnswer}
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default CodingSnippetEntry;
